import './style.scss';

// FileGrid Component JavaScript

document.addEventListener('DOMContentLoaded', function() {
    const components = document.querySelectorAll('.booom-filegrid');

    components.forEach(function(component) {
        const fileItems = component.querySelectorAll('.file-item');

        fileItems.forEach(function(item) {
            const pdfPreview = item.querySelector('.pdf-preview');
            const iframe = item.querySelector('iframe[type="application/pdf"]');
            const shimmer = item.querySelector('.pdf-shimmer');

            // Handle PDF loading and hide shimmer when loaded
            if (iframe && shimmer) {
                const hideShimmer = () => {
                    if (shimmer) {
                        shimmer.classList.add('loaded');
                        iframe.classList.add('loaded');
                        setTimeout(() => {
                            if (shimmer.parentNode) {
                                shimmer.remove();
                            }
                        }, 300);
                    }
                };

                // Listen for load event
                iframe.addEventListener('load', function() {
                    setTimeout(() => {
                        hideShimmer();
                    }, 1000);
                });

                // Fallback: hide shimmer after max wait time
                setTimeout(() => {
                    hideShimmer();
                }, 3000);
            }

            // Make PDF preview clickable to open in new tab
            if (pdfPreview) {
                pdfPreview.style.cursor = 'pointer';
                pdfPreview.addEventListener('click', function() {
                    const link = item.querySelector('a');
                    if (link) {
                        window.open(link.href, '_blank');
                    }
                });
            }
        });
    });
});
